/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Create_TitleInputs */

const en_carrier_notices_create_title = /** @type {(inputs: Carrier_Notices_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create carrier notice`)
};

const es_carrier_notices_create_title = /** @type {(inputs: Carrier_Notices_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear aviso de transportista`)
};

/**
* | output |
* | --- |
* | "Create carrier notice" |
*
* @param {Carrier_Notices_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_create_title = /** @type {((inputs?: Carrier_Notices_Create_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Create_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_create_title(inputs)
	return es_carrier_notices_create_title(inputs)
});